import { render, staticRenderFns } from "./annexNewsForm.vue?vue&type=template&id=cc279d30&"
import script from "./annexNewsForm.vue?vue&type=script&lang=js&"
export * from "./annexNewsForm.vue?vue&type=script&lang=js&"
import style0 from "./annexNewsForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "annexNewsForm.vue"
export default component.exports